export var IntegratorServiceSectionType;
(function (IntegratorServiceSectionType) {
    IntegratorServiceSectionType["OVERVIEW"] = "overview";
    IntegratorServiceSectionType["DOCUMENT"] = "document";
    IntegratorServiceSectionType["BENEFITS"] = "benefits";
    IntegratorServiceSectionType["CONTACT_LAWYER"] = "contact-lawyer";
    IntegratorServiceSectionType["IMAGE"] = "image";
})(IntegratorServiceSectionType || (IntegratorServiceSectionType = {}));
//# sourceMappingURL=integrator-service.js.map